import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const SimplePreview = ({
                         imageSrc,
                         onConfirm,
                         onReject,
                       }) => {

  return (
    <>
      <div className={styles.modalApiImage}>
        {imageSrc && (
          <img src={imageSrc} alt="content" className={styles.image}/>
        )}
      </div>
      <div className={styles.modalButtons}>
        <button
          type="button"
          className={styles.buttonCancel}
          onClick={onReject}
        >
          <span>ביטול</span>
        </button>
        <button
          type="button"
          className={styles.buttonSubmit}
          onClick={onConfirm}
        >
          <span>אשר והוסף לשומה</span>
        </button>
      </div>
    </>
  );
};

SimplePreview.propTypes = {
  imageSrc: PropTypes.string,
};

export default SimplePreview;
